// components/IconComponent.jsx
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faMugHot, faCircle,faLocationDot  } from "@fortawesome/free-solid-svg-icons";

const iconMap = {
  "map-marker": faLocationDot,
  "tea": faMugHot,
  "circle-slice-8": faCircle, // Choose a suitable icon for this
};

const IconComponent = ({ iconName, className = "text-lg" }) => {
  return (
    <div className="w-12 h-12 flex items-center justify-center rounded-full border bg-gray-200 dark:bg-gray-800">
      {iconMap[iconName] ? (
        <FontAwesomeIcon icon={iconMap[iconName]} className={className} />
      ) : (
        <span className="text-xs text-gray-500">?</span> // Default fallback
      )}
    </div>
  );
};

export default IconComponent;
